import { FC } from "react";
import { IconProps } from "./types";

export const Filter: FC<IconProps> = ({
  fill = "#111111",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M20.2264 4H3.77877C3.34785 4 3 4.34627 3 4.77522V7.22492C3 7.44715 3.09345 7.65388 3.25959 7.80376L8.95501 12.8582V18.2227C8.95501 18.4295 9.03807 18.6259 9.18344 18.7706C9.32881 18.9153 9.5261 18.998 9.73378 18.998H9.73897C11.2757 18.9876 13.7886 18.9773 14.1624 18.9928C14.2455 19.0031 14.3233 19.0031 14.4064 18.9876C14.775 18.9204 15.045 18.6 15.045 18.2227L15.0346 12.8582L20.7404 7.80376C20.9065 7.65905 21 7.44715 21 7.22492V4.77522C21 4.34627 20.6521 4 20.2212 4H20.2264ZM19.4477 6.87349L13.7419 11.9279C13.5757 12.0778 13.4823 12.2845 13.4823 12.5068L13.4926 17.4424C13.1708 17.432 12.771 17.432 12.2726 17.432C11.7742 17.432 11.2083 17.432 10.5177 17.4372V12.5016C10.5177 12.2794 10.4243 12.0726 10.2582 11.9228L4.56273 6.86832V5.54011H19.4528V6.86315L19.4477 6.87349Z"
      fill={fill}
    />
  </svg>
);
